import BaseGallery from 'ui/BaseGallery';
import ProGallery from 'ui/ProGallery';

function GalleryFactory(RMI, compId, contextId, wixSelector, controllerId, role, type) {
    switch(type.viewerType) {
        case 'wysiwyg.viewer.components.tpapps.TPAWidget':
            return new ProGallery(RMI, compId, contextId, wixSelector, controllerId, role, type);
        default:
            return new BaseGallery(RMI, compId, contextId, wixSelector, controllerId, role, type);
    }
}

export default GalleryFactory;



// WEBPACK FOOTER //
// ./js/modules/ui/Gallery.es6